import { render, staticRenderFns } from "./DiscoveryCard.vue?vue&type=template&id=e681c656&scoped=true"
import script from "./DiscoveryCard.vue?vue&type=script&lang=js"
export * from "./DiscoveryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e681c656",
  null
  
)

export default component.exports